import React from 'react'
import { Chip as MatChip } from '@material-ui/core'
import './Chip.scss'
import classNames from 'classnames'

export const Chip = ({ className, ...rest }) => <MatChip className={classNames(className, 'ui-chip')} {...rest} />
